import { Library } from '../../../components/Library/Admin'

export const FileList = () => {
    return <Library />
}
